import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { selectZaConfig, selectZaRunningContext } from '../root/reducer'
import Image from './Image'

const supportedShareContexts = ['inMeeting', 'inWebinar'] // TODO more research needed on support for contexts

function SearchResult({ image, showAttribution = true, selectedImage, index }) {
  const searchResultRef = useRef()
  const resultSelected = selectedImage === image
  const zaConfig = useSelector(selectZaConfig) || {}
  const zaRunningContext = useSelector(selectZaRunningContext)
  const { unsupportedApis = [] } = zaConfig
  const showAppInvitationDialogSupported = !unsupportedApis.includes(
    'showAppInvitationDialog'
  )
  const contextSupported = supportedShareContexts.includes(zaRunningContext)
  const showSharing = contextSupported && showAppInvitationDialogSupported

  useEffect(() => {
    if (resultSelected) {
      searchResultRef.current?.focus()
      const elPosition = searchResultRef.current.getBoundingClientRect()
      // the magic numbers here belong to the height of the sticky search bar and the footer
      const topPosition = elPosition.top >= 115
      const bottomPosition =
        elPosition.bottom <=
        (window.innerHeight - 40 || document.documentElement.clientHeight - 40)
      const inView = topPosition && bottomPosition

      if (!inView)
        searchResultRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        })
    }
  }, [resultSelected])

  return (
    <li
      className="SearchResult"
      aria-label={`Image and User for ${image.alt}`}
      ref={searchResultRef}
      data-id={`insideImagesContainer_${index}`}
      tabIndex={resultSelected ? '0' : '-1'}
    >
      <Image
        image={image}
        resultSelected={resultSelected}
        index={index}
        showAttribution={showAttribution}
        showSharing={showSharing}
      />
    </li>
  )
}

export default SearchResult
